import React from 'react';
import image from './pos-banner.webp'
const PosAdBanner = () => {
  return (
    <div className="container w-full mb-6 md:mb-10 rounded-xl" style={{backgroundColor: "#efede3"}}>
      <div className="container mx-auto px-3 md:px-4 pt-6 md:pt-12">
        {/* Responsive container - column on mobile, row on tablet/desktop */}
        <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8">
          {/* Text Section */}
          <div className="w-full md:w-1/2 text-left">
            <h1 className="text-lg sm:text-xl font-extrabold sm:text-4xl lg:text-4xl mb-2">
              The All-in-One Beauty Salon & Spa Management Software
            </h1>

            <p className="text-sm sm:text-base md:text-lg text-gray-700 mb-3 md:mb-4">
              Empowering salon and spa owners with an all-in-one, AI-driven SaaS platform that simplifies management, enhances customer engagement, and drives growth—bridging the gap between tradition and technology
            </p>
            
            {/* Software Features Bullet Points - Simple Layout */}
            <div className="mb-4 md:mb-6">
              <h2 className="text-xl md:text-2xl font-bold mb-2 md:mb-4">Salon & Spa Software Solutions</h2>
              <ul className="grid grid-cols-2 gap-4 md:gap-2 text-sm sm:text-base">
                <li className="flex items-start">
                  <span><strong>Smart Appointment Scheduling</strong><br></br> Online booking & automated reminders</span>
                </li>
                <li className="flex items-start">
                  <span><strong>Client Management</strong><br></br> CRM & personalized customer engagement</span>
                </li>
                <li className="flex items-start">
                  <span><strong>Billing & POS Integration</strong><br></br> Seamless Billing & order management</span>
                </li>
                <li className="flex items-start">
                  <span><strong>Inventory & Staff Management</strong><br></br> Optimize resources efficiently</span>
                </li>
                <li className="flex items-start"><span><strong>WhatsApp Notifications</strong><br /> Keep clients engaged with automated reminders and updates</span></li>

                <li className="flex items-start">
                  <span><strong>Data Analytics & Reports</strong><br></br> Data-driven business growth strategies</span>
                </li>
                <li className="mt-4 md:mt-8">
                <button onClick={() => window.location.href = "https://pos.feelaxo.com/admin/register"} className="bg-black hover:bg-red-600 text-white md:py-3 px-4 md:px-6 rounded-md font-medium transition-colors text-xs md:text-sm py-2 md:text-base">
                  Get Started for Free!
                  </button>
                </li>
                <li className='mt-4 text-xs md:mt-8 md:flex md:items-center md:text-sm md:text-base'>
                Already registered?&nbsp;&nbsp;<a href="https://pos.feelaxo.com/" className="text-blue-600 underline"> Login now</a>
                </li>
                <li className="text-xs md:text-sm">
                *no credit card required.
                </li>
              </ul>
            </div>
            
              
          </div>
          
          {/* Image Section */}
          <div className="w-full flex md:w-1/2 mt-4 md:mt-0 items-baseline">
          <a href="https://pos.feelaxo.com/admin/register" title="Book Free Demo">
            <img 
              src={image}
              alt="Beauty Salon POS Software" 
              className="w-full h-auto rounded-lg"
            />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PosAdBanner;